import { pluralize } from 'numeralize-ru';

const PluralUtil = (n, one, two, three) => {
	if (one instanceof Array) {
		return pluralize(n, ...one);
	} else {
		return pluralize(n, one, two, three)
	}
};

export default PluralUtil;
